var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { formTextBorderStyles, useFormTextStateProps, } from '../context';
var StyledTextInputWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  width: 100%;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  width: 100%;\n  ", "\n"])), function (_a) {
    var $maxWidth = _a.$maxWidth;
    return "\n    ".concat($maxWidth ? "max-width: ".concat($maxWidth, ";") : '', "\n  ");
});
var StyledFormTextBorder = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), formTextBorderStyles);
export var FormTextWrapper = React.forwardRef(function (_a, ref) {
    var maxWidth = _a.maxWidth, children = _a.children;
    var formTextStateProps = useFormTextStateProps({});
    return (React.createElement(StyledTextInputWrapper, { ref: ref, "$maxWidth": maxWidth, "data-testid": "mui-form-text-wrapper" },
        children,
        React.createElement(StyledFormTextBorder, __assign({}, formTextStateProps))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormTextWrapper.js.map